import { useState } from 'react';

import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Title from 'shared/components/Title';
import SpaceRenovationRequestCreateForm from '../SpaceRenovationRequestCreateForm';
import DownloadRepairInstructionsButton from './DownloadRepairInstructionsButton';

const TopBar = () => {
  const [
    showedSpaceRenovationRequestCreateForm,
    showSpaceRenovationRequestCreateForm,
  ] = useState(false);

  const handleOpenCreateForm = () => {
    showSpaceRenovationRequestCreateForm(true);
  };

  const handleCloseCreateForm = () => {
    showSpaceRenovationRequestCreateForm(false);
  };

  return (
    <>
      <Stack alignItems="center" direction="row" spacing={3}>
        <Title>Huoneiston muutostyöt</Title>
        <Stack
          direction="row"
          flex={1}
          justifyContent="space-between"
          spacing={2}
        >
          <Button
            color="success"
            sx={{ fontWeight: 600 }}
            onClick={handleOpenCreateForm}
          >
            UUSI MUUTOSTYÖ
          </Button>
          <DownloadRepairInstructionsButton />
        </Stack>
      </Stack>
      {showedSpaceRenovationRequestCreateForm && (
        <SpaceRenovationRequestCreateForm onClose={handleCloseCreateForm} />
      )}
    </>
  );
};

export default TopBar;
